export const PAST_FORECAST_TIME_ERROR = 'Solo los Super Admin pueden generar pronósticos con fecha u hora anterior al reloj de este dispositivo.';

export const startOfLocalMinute = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }
  const normalized = new Date(date.getTime());
  normalized.setSeconds(0, 0);
  return normalized;
};

export const isBeforeDeviceCurrentMinute = (value) => {
  if (!value) {
    return false;
  }
  const date = value instanceof Date ? value : new Date(value);
  const selectedMinute = startOfLocalMinute(date);
  const currentMinute = startOfLocalMinute(new Date());
  if (!selectedMinute || !currentMinute) {
    return false;
  }
  return selectedMinute.getTime() < currentMinute.getTime();
};

export const toLocalMinuteInputValue = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return '';
  }
  const tzoffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - tzoffset).toISOString().slice(0, 16);
};
